import axios from 'axios';
import { useEffect, useState } from 'react';
import { config } from '../../config';

// TODO remove hardcoded user when we develop the feature
const TEST_ASSET_ID = '6111A48C-FB46-47A5-8A8F-0FF0C1365F02';

// TODO To be removed/updated when a new project is created.
const useFetchExample = () => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [hasErrors, setHasErrors] = useState<boolean>(false);
    const [exampleText, setExampleText] = useState<string>('');
    const [reloadState, setReloadState] = useState<{}>({});
    const triggerReload = () => {
        setHasErrors(false);
        setReloadState({});
    };
    useEffect(() => {
        if (config.backend.BACKEND_URI) {
            axios
                .get(config.backend.BACKEND_URI + '/maintenance-history' + `?asset_id=${TEST_ASSET_ID}`)
                .then((res) => {
                    setExampleText(`Received ${res.data.length} rows from backend.`);
                    setIsLoading(false);
                })
                .catch((error) => {
                    console.error('Error fetching example endpoint', error);
                    setHasErrors(true);
                });
        }
    }, [reloadState]);
    return {
        isLoading,
        hasErrors,
        exampleText,
        triggerReload,
    };
};

export default useFetchExample;
